import { z } from 'zod';
import { BrandDNASchema } from '../brand';
import { ResolvedPromptSchema, TemplateSchema } from '../template';

export const PromptFillJobInputSchema = z
  .object({
    brandId: z.string(),
    brandName: z.string(),
    template: TemplateSchema,
    llmModelId: z.string(),
    numImages: z.number().int().min(1).max(10),
    /** Inline brand DNA, used when caller already has it. */
    dna: BrandDNASchema.optional(),
    /** id of an upstream research job whose output supplies brand DNA. */
    researchJobId: z.string().optional(),
    /** Optional per-batch concept brief from the user, woven into placeholder fills. */
    conceptBrief: z.string().optional(),
    /** Subset of brand product images to share as visual reference with the prompt-writing LLM. Only used when the template requires product images. */
    productImageIds: z.array(z.string()).optional(),
  })
  .refine((d) => Boolean(d.dna) || Boolean(d.researchJobId), {
    message: 'PromptFillJobInput requires either dna or researchJobId.',
  });
export type PromptFillJobInput = z.infer<typeof PromptFillJobInputSchema>;

export const PromptFillJobOutputSchema = z.object({
  resolved: ResolvedPromptSchema,
  /** Dexie id of the persisted ResolvedPromptRow, for downstream reuse. */
  resolvedPromptRowId: z.string(),
});
export type PromptFillJobOutput = z.infer<typeof PromptFillJobOutputSchema>;
